var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"diagnosis-menu",attrs:{"id":"menu"}},[_c('h1',[_vm._v(_vm._s(this.$japaneseMenu))]),_c('img',{attrs:{"src":this.$imgTitleBar}}),_c('h2',[_vm._v(_vm._s(_vm.menu))])]),_c('div',{staticClass:"menus"},[_c('Menu')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }